import { SRG_LOGIN_LOGGED_IN } from "@Constants/SrgLoginEvents";
import {
  FAKE_ID_TOKEN,
  FAKE_PREFERRED_USERNAME,
  FAKE_USER_ID,
} from "@Constants/user";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const triggerEvent = (event: string, data: any = null): void => {
  const customEvent = new CustomEvent(event, {
    detail: data,
    bubbles: true,
    cancelable: true,
  });

  window.dispatchEvent(customEvent);
};

export const triggerFakeLoggedInEvent = (): void => {
  triggerEvent(SRG_LOGIN_LOGGED_IN, {
    user: {
      profile: {
        preferred_username: FAKE_PREFERRED_USERNAME,
        sub: FAKE_USER_ID,
      },
      id_token: FAKE_ID_TOKEN,
    },
  });
};
